import React from "react";

const RoundTrueIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#34A265"
        d="M8.001 16a7.8 7.8 0 0 1-3.12-.63 8.1 8.1 0 0 1-2.54-1.71 8.1 8.1 0 0 1-1.71-2.54A7.8 7.8 0 0 1 0 8.002q0-1.659.63-3.12.63-1.46 1.71-2.54A8.1 8.1 0 0 1 4.88.63 7.8 7.8 0 0 1 8 0q1.05 0 2.037.268a8.2 8.2 0 0 1 1.887.775q.243.135.317.392.074.256-.087.478a.7.7 0 0 1-.428.277.73.73 0 0 1-.515-.08 6.7 6.7 0 0 0-1.554-.63A6.4 6.4 0 0 0 8 1.263q-2.8 0-4.768 1.969Q1.262 5.2 1.263 8t1.969 4.768Q5.2 14.738 8 14.737t4.768-1.969Q14.738 10.8 14.737 8q0-.244-.019-.474a5 5 0 0 0-.064-.47.8.8 0 0 1 .092-.514.63.63 0 0 1 .405-.318.56.56 0 0 1 .472.063q.218.135.26.392A7 7 0 0 1 16 8q0 1.66-.63 3.12t-1.71 2.54a8.1 8.1 0 0 1-2.54 1.71Q9.663 16 8.002 16M6.805 9.807l7.864-7.877a.627.627 0 1 1 .887.888L7.338 11.05a.73.73 0 0 1-.533.228.73.73 0 0 1-.533-.229L3.961 8.74a.6.6 0 0 1-.179-.44.6.6 0 0 1 .18-.448.6.6 0 0 1 .443-.183q.261 0 .444.183z"
      ></path>
    </svg>
  );
};

export default RoundTrueIcon;
